// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4_postcss@8.5.16_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4_postcss@8.5.16_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-wrapper {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
    position: relative;
    background-color: #272a30;
    display: flex;
    flex-direction: column;
    touch-action: none;
}

.chart-main {
    overflow: hidden;
    position: relative;
    background-color: #272a30;
    flex: 1 1 auto;
    min-height: 0;
}

.chart-sub {
    overflow: hidden;
    position: relative;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    flex: 0 0 auto;
}

.chart-canvas {
    display: block;
    width: 100%;
    height: 100%;
    cursor: crosshair;
    touch-action: none;
}

.chart-resize-handle {
    height: 4px;
    width: 100%;
    cursor: ns-resize;
    background-color: #272a30;
    flex: 0 0 4px;
    touch-action: none;
}

.chart-resize-handle:hover {
    background-color: #269ea6;
}

.chart-toolbar {
    display: flex;
    gap: 12px;
    align-items: center;
    z-index: 10;
    padding: 6px 10px;
    background-color: #1a1d26;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    flex: 0 0 auto;
    font-family: Arial, sans-serif;
    font-size: 13px;
    color: white;
    touch-action: none;
}

.chart-toolbar label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
}

.chart-toolbar select {
    background-color: #272a30;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    padding: 3px 6px;
    font-size: 13px;
    font-family: Arial, sans-serif;
    cursor: pointer;
    outline: none;
}

.chart-toolbar select:hover {
    border-color: #269ea6;
}

.chart-toolbar select:focus {
    border-color: #269ea6;
}

.chart-toolbar-intervals {
    display: flex;
    gap: 4px;
    align-items: center;
}

.chart-toolbar-intervals button {
    background-color: #272a30;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    padding: 3px 8px;
    font-size: 12px;
    font-family: Arial, sans-serif;
    cursor: pointer;
}

.chart-toolbar-intervals button:hover {
    border-color: #269ea6;
}

.chart-toolbar-intervals button.is-active {
    background-color: #269ea6;
    border-color: #269ea6;
    color: white;
}

.chart-sidebar {
    width: 0;
    flex-shrink: 0;
    background-color: #1a1d26;
    border-left: none;
    transition: width 0.2s ease;
    color: white;
    font-family: Arial, sans-serif;
    overflow: hidden;
    touch-action: none;
}

.chart-sidebar--open {
    width: 340px;
    border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.chart-sidebar-toggle {
    width: 28px;
    height: 28px;
    background-color: rgba(20, 24, 35, 0.85);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
}

.chart-sidebar-toggle:hover {
    border-color: #269ea6;
}

.chart-rail {
    width: 36px;
    flex-shrink: 0;
    background-color: #1a1d26;
    border-left: 1px solid rgba(255, 255, 255, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 10px;
    touch-action: none;
}

.chart-body {
    position: relative;
    display: flex;
    flex: 1 1;
    min-height: 0;
    width: 100%;
}

.chart-column {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    min-width: 0;
}

.chart-sidebar-content {
    width: 340px;
    height: 100%;
    box-sizing: border-box;
    padding: 12px;
    display: flex;
    flex-direction: column;
}

.chart-sidebar-head {
    font-size: 15px;
    font-weight: bold;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.chart-sidebar-list {
    list-style: none;
    margin: 8px 0;
    padding: 0;
    overflow-y: auto;
    flex: 1 1;
}

.chart-sidebar-info {
    height: 40%;
    flex-shrink: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 8px;
    overflow-y: auto;
}

.chart-sidebar-info-head {
    display: flex;
    align-items: center;
    gap: 8px;
}

.chart-sidebar-info-thumb {
    width: 28px;
    height: 28px;
}

.chart-sidebar-info-symbol {
    font-size: 17px;
    font-weight: bold;
}

.chart-sidebar-info-name {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
}

.chart-sidebar-info-price {
    font-size: 30px;
    font-weight: bold;
    margin: 8px 0;
    font-variant-numeric: tabular-nums;
}

.chart-sidebar-info-price.is-up {
    color: #26a69a;
}

.chart-sidebar-info-price.is-down {
    color: #ef5350;
}

.chart-sidebar-info-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2px 0;
    font-size: 13px;
}

.chart-sidebar-info-grid > div {
    display: flex;
    align-items: center;
    padding: 3px 0;
}

.chart-sidebar-info-grid span {
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
    width: 150px;
    flex-shrink: 0;
}

.chart-sidebar-info-grid b {
    font-weight: normal;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
    margin-left: auto;
    text-align: right;
}

.chart-sidebar-info-grid b.is-up {
    color: #26a69a;
}

.chart-sidebar-info-grid b.is-down {
    color: #ef5350;
}

.chart-sidebar-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}

.chart-sidebar-item:hover {
    background-color: rgba(255, 255, 255, 0.06);
}

.chart-sidebar-symbol {
    font-weight: normal;
    font-size: 14px;
    width: 90px;
    flex-shrink: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chart-sidebar-thumb {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    flex-shrink: 0;
}

.chart-sidebar-price {
    font-size: 14px;
    font-variant-numeric: tabular-nums;
    min-width: 84px;
    text-align: right;
}

.chart-sidebar-quote {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    gap: 8px;
    flex: 1 1;
    min-width: 0;
}

.chart-sidebar-pct {
    font-size: 14px;
    font-variant-numeric: tabular-nums;
    min-width: 78px;
    text-align: right;
}

.chart-sidebar-price.is-up,
.chart-sidebar-pct.is-up,
.chart-sidebar-symbol.is-up {
    color: #26a69a;
}

.chart-sidebar-price.is-down,
.chart-sidebar-pct.is-down,
.chart-sidebar-symbol.is-down {
    color: #ef5350;
}

.chart-sidebar-remove {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    font-size: 12px;
    padding: 0 2px;
}

.chart-sidebar-remove:hover {
    color: #ef5350;
}

.chart-sidebar-add {
    display: flex;
    gap: 6px;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.chart-sidebar-search {
    position: relative;
    flex: 1 1;
    min-width: 0;
    display: flex;
}

.chart-sidebar-add input {
    flex: 1 1;
    min-width: 0;
    background-color: #272a30;
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    padding: 4px 6px;
    font-size: 13px;
    font-family: Arial, sans-serif;
    outline: none;
}

.chart-sidebar-add input:focus {
    border-color: #269ea6;
}

.chart-sidebar-add button {
    background-color: #269ea6;
    color: white;
    border: none;
    border-radius: 4px;
    width: 26px;
    cursor: pointer;
    font-size: 14px;
}

.chart-sidebar-suggestions {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 4px);
    max-height: 180px;
    overflow-y: auto;
    list-style: none;
    margin: 0;
    padding: 4px 0;
    background-color: #1a1d26;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    z-index: 22;
}

.chart-sidebar-suggestions li {
    padding: 4px 8px;
    font-size: 13px;
    cursor: pointer;
}

.chart-sidebar-suggestions li:hover {
    background-color: rgba(255, 255, 255, 0.08);
}

.chart-sidebar-nosuggest {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 4px);
    padding: 6px 8px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    background-color: #1a1d26;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    z-index: 22;
}
`, "",{"version":3,"sources":["webpack://./src/chart/styles/style.chart.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,iDAAiD;IACjD,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,gDAAgD;IAChD,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAO;IACP,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,WAAW;IACX,cAAc;IACd,8CAA8C;IAC9C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kCAAkC;IAClC,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,QAAQ;IACR,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;AACf","sourcesContent":[".chart-wrapper {\n    width: 100vw;\n    height: 100vh;\n    height: 100dvh;\n    overflow: hidden;\n    position: relative;\n    background-color: #272a30;\n    display: flex;\n    flex-direction: column;\n    touch-action: none;\n}\n\n.chart-main {\n    overflow: hidden;\n    position: relative;\n    background-color: #272a30;\n    flex: 1 1 auto;\n    min-height: 0;\n}\n\n.chart-sub {\n    overflow: hidden;\n    position: relative;\n    border-top: 1px solid rgba(255, 255, 255, 0.15);\n    flex: 0 0 auto;\n}\n\n.chart-canvas {\n    display: block;\n    width: 100%;\n    height: 100%;\n    cursor: crosshair;\n    touch-action: none;\n}\n\n.chart-resize-handle {\n    height: 4px;\n    width: 100%;\n    cursor: ns-resize;\n    background-color: #272a30;\n    flex: 0 0 4px;\n    touch-action: none;\n}\n\n.chart-resize-handle:hover {\n    background-color: #269ea6;\n}\n\n.chart-toolbar {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    z-index: 10;\n    padding: 6px 10px;\n    background-color: #1a1d26;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    flex: 0 0 auto;\n    font-family: Arial, sans-serif;\n    font-size: 13px;\n    color: white;\n    touch-action: none;\n}\n\n.chart-toolbar label {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.7);\n}\n\n.chart-toolbar select {\n    background-color: #272a30;\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n    padding: 3px 6px;\n    font-size: 13px;\n    font-family: Arial, sans-serif;\n    cursor: pointer;\n    outline: none;\n}\n\n.chart-toolbar select:hover {\n    border-color: #269ea6;\n}\n\n.chart-toolbar select:focus {\n    border-color: #269ea6;\n}\n\n.chart-toolbar-intervals {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n}\n\n.chart-toolbar-intervals button {\n    background-color: #272a30;\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n    padding: 3px 8px;\n    font-size: 12px;\n    font-family: Arial, sans-serif;\n    cursor: pointer;\n}\n\n.chart-toolbar-intervals button:hover {\n    border-color: #269ea6;\n}\n\n.chart-toolbar-intervals button.is-active {\n    background-color: #269ea6;\n    border-color: #269ea6;\n    color: white;\n}\n\n.chart-sidebar {\n    width: 0;\n    flex-shrink: 0;\n    background-color: #1a1d26;\n    border-left: none;\n    transition: width 0.2s ease;\n    color: white;\n    font-family: Arial, sans-serif;\n    overflow: hidden;\n    touch-action: none;\n}\n\n.chart-sidebar--open {\n    width: 340px;\n    border-left: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.chart-sidebar-toggle {\n    width: 28px;\n    height: 28px;\n    background-color: rgba(20, 24, 35, 0.85);\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 1;\n}\n\n.chart-sidebar-toggle:hover {\n    border-color: #269ea6;\n}\n\n.chart-rail {\n    width: 36px;\n    flex-shrink: 0;\n    background-color: #1a1d26;\n    border-left: 1px solid rgba(255, 255, 255, 0.15);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 10px;\n    touch-action: none;\n}\n\n.chart-body {\n    position: relative;\n    display: flex;\n    flex: 1;\n    min-height: 0;\n    width: 100%;\n}\n\n.chart-column {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-width: 0;\n}\n\n.chart-sidebar-content {\n    width: 340px;\n    height: 100%;\n    box-sizing: border-box;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n}\n\n.chart-sidebar-head {\n    font-size: 15px;\n    font-weight: bold;\n    padding-bottom: 12px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.chart-sidebar-list {\n    list-style: none;\n    margin: 8px 0;\n    padding: 0;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.chart-sidebar-info {\n    height: 40%;\n    flex-shrink: 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    padding-top: 8px;\n    overflow-y: auto;\n}\n\n.chart-sidebar-info-head {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.chart-sidebar-info-thumb {\n    width: 28px;\n    height: 28px;\n}\n\n.chart-sidebar-info-symbol {\n    font-size: 17px;\n    font-weight: bold;\n}\n\n.chart-sidebar-info-name {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.chart-sidebar-info-price {\n    font-size: 30px;\n    font-weight: bold;\n    margin: 8px 0;\n    font-variant-numeric: tabular-nums;\n}\n\n.chart-sidebar-info-price.is-up {\n    color: #26a69a;\n}\n\n.chart-sidebar-info-price.is-down {\n    color: #ef5350;\n}\n\n.chart-sidebar-info-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 2px 0;\n    font-size: 13px;\n}\n\n.chart-sidebar-info-grid > div {\n    display: flex;\n    align-items: center;\n    padding: 3px 0;\n}\n\n.chart-sidebar-info-grid span {\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 12px;\n    width: 150px;\n    flex-shrink: 0;\n}\n\n.chart-sidebar-info-grid b {\n    font-weight: normal;\n    font-size: 13px;\n    font-variant-numeric: tabular-nums;\n    margin-left: auto;\n    text-align: right;\n}\n\n.chart-sidebar-info-grid b.is-up {\n    color: #26a69a;\n}\n\n.chart-sidebar-info-grid b.is-down {\n    color: #ef5350;\n}\n\n.chart-sidebar-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.chart-sidebar-item:hover {\n    background-color: rgba(255, 255, 255, 0.06);\n}\n\n.chart-sidebar-symbol {\n    font-weight: normal;\n    font-size: 14px;\n    width: 90px;\n    flex-shrink: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.chart-sidebar-thumb {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.chart-sidebar-price {\n    font-size: 14px;\n    font-variant-numeric: tabular-nums;\n    min-width: 84px;\n    text-align: right;\n}\n\n.chart-sidebar-quote {\n    display: flex;\n    align-items: baseline;\n    justify-content: flex-end;\n    gap: 8px;\n    flex: 1;\n    min-width: 0;\n}\n\n.chart-sidebar-pct {\n    font-size: 14px;\n    font-variant-numeric: tabular-nums;\n    min-width: 78px;\n    text-align: right;\n}\n\n.chart-sidebar-price.is-up,\n.chart-sidebar-pct.is-up,\n.chart-sidebar-symbol.is-up {\n    color: #26a69a;\n}\n\n.chart-sidebar-price.is-down,\n.chart-sidebar-pct.is-down,\n.chart-sidebar-symbol.is-down {\n    color: #ef5350;\n}\n\n.chart-sidebar-remove {\n    background: none;\n    border: none;\n    color: rgba(255, 255, 255, 0.5);\n    cursor: pointer;\n    font-size: 12px;\n    padding: 0 2px;\n}\n\n.chart-sidebar-remove:hover {\n    color: #ef5350;\n}\n\n.chart-sidebar-add {\n    display: flex;\n    gap: 6px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.chart-sidebar-search {\n    position: relative;\n    flex: 1;\n    min-width: 0;\n    display: flex;\n}\n\n.chart-sidebar-add input {\n    flex: 1;\n    min-width: 0;\n    background-color: #272a30;\n    color: white;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n    padding: 4px 6px;\n    font-size: 13px;\n    font-family: Arial, sans-serif;\n    outline: none;\n}\n\n.chart-sidebar-add input:focus {\n    border-color: #269ea6;\n}\n\n.chart-sidebar-add button {\n    background-color: #269ea6;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    width: 26px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.chart-sidebar-suggestions {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(100% + 4px);\n    max-height: 180px;\n    overflow-y: auto;\n    list-style: none;\n    margin: 0;\n    padding: 4px 0;\n    background-color: #1a1d26;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n    z-index: 22;\n}\n\n.chart-sidebar-suggestions li {\n    padding: 4px 8px;\n    font-size: 13px;\n    cursor: pointer;\n}\n\n.chart-sidebar-suggestions li:hover {\n    background-color: rgba(255, 255, 255, 0.08);\n}\n\n.chart-sidebar-nosuggest {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(100% + 4px);\n    padding: 6px 8px;\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.5);\n    background-color: #1a1d26;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n    z-index: 22;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
